import React from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { UserCircle2 } from "lucide-react";

export function OperatorLinkDialog({
  isOpen,
  onOpenChange,
  operators,
  onLinkOperator
}) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <UserCircle2 className="h-5 w-5 text-blue-600" />
            Collega Profilo Operatore
          </DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <p className="text-sm text-slate-600 mb-4">
            Seleziona il tuo profilo operatore per tracciare automaticamente le tue attività 
            (creazione pratiche, cambi stato, storico).
          </p>
          <div className="space-y-2">
            {operators.filter(op => op.status !== "sospeso").map((op) => (
              <Button
                key={op.id}
                variant="outline"
                className="w-full justify-start h-auto py-3"
                onClick={() => onLinkOperator(op.id)}
                data-testid={`link-operator-${op.id}`}
              >
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <UserCircle2 className="h-5 w-5 text-blue-600" />
                  </div>
                  <div className="text-left">
                    <p className="font-medium">{op.fullName}</p>
                    {op.email && (
                      <p className="text-xs text-slate-500">{op.email}</p>
                    )}
                  </div>
                </div>
              </Button>
            ))}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annulla
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
